module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar-container",
    style: (("height: calc(48px * " + (_vm.actions.length) + ")"))
  }, _vm._l((_vm.actions), function(action) {
    return _c('action', {
      key: action.id,
      attrs: {
        "action": action
      },
      on: {
        "open-action": function($event) {
          _vm.openAction(action)
        }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16f7d3e9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/actionBar/action-bar.vue
// module id = 1592
// module chunks = 18